export const formatBalance = (balance: String) => {
    let [left, right] = balance.split('.')
    left = left.replace(/\B(?=(\d{3})+(?!\d))/g, ",")

    return right ? `${left}.${right}` : left
}